export const swiperConfig = {
  speed: 400,
  slidesPerView: 'auto',
  centeredSlides: true,
  shortSwipes: true,
  touchEventsTarget: 'wrapper',
  threshold: 80,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    // Swiper 12 injects SVG arrows into the nav buttons by default;
    // our nav buttons are custom-styled components, so keep them icon-free
    addIcons: false
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar'
  }
};
